export default __webpack_public_path__ + "static/media/Revenue_detailed_client.591b9f64.xlsx";